import React, {Fragment } from "react";
import { useTranslation } from 'react-i18next';
import ProductPoints from './ProductPoints';
import { Drop } from '../common/enums';

export default function (props) {
    const { t } = useTranslation();
    const { product } = props;

    if (!product) return <div />;
    const benefitsOverview = product.benefitOverview ? (
        <div className="card">
            <div className="card-header" role="tab">
                <h6>
                    <a
                        
                        href="#collapseBenefitOverview"
                        data-toggle="collapse"
                        data-parent="#productInfoAccordion"
                    >
                        <i className="icon-arrow-right" />{t("BenefitOverview")}
                    </a>
                </h6>
            </div>
            <div className="collapse show" id="collapseBenefitOverview" role="tabpanel">
                <div className="card-body" style={{ whiteSpace: "pre-wrap" }}>{product.benefitOverview}</div>
            </div>
        </div>
    ) : "";

    const usage = product.usage ? (
        <div className="card">
            <div className="card-header" role="tab">
                <h6>
                    <a
                        className="collapsed"
                        href="#collapseUsage"
                        data-toggle="collapse"
                        data-parent="#productInfoAccordion"
                    >
                        <i className="icon-sun" />{t("Usage")}
            </a>
                </h6>
            </div>
            <div className="collapse" id="collapseUsage" role="tabpanel">
                <div className="card-body" style={{ whiteSpace: "pre-wrap" }}>{product.usage}</div>
            </div>
        </div>
    ) : "";

    const hints = product.hint ? (
        <div className="card">
            <div className="card-header" role="tab">
                <h6>
                    <a
                        className="collapsed"
                        href="#collapseHint"
                        data-toggle="collapse"
                        data-parent="#productInfoAccordion"
                    >
                        <i className="icon-arrow-right" />{t("Hint")}
            </a>
                </h6>
            </div>
            <div className="collapse" id="collapseHint" role="tabpanel">
                <div className="card-body" style={{ whiteSpace: "pre-wrap" }}>{product.hint}</div>
            </div>
        </div>
    ) : "";

    const notes = product.notes ? (
        <div className="card">
            <div className="card-header" role="tab">
                <h6>
                    <a
                        className="collapsed"
                        href="#collapseNotes"
                        data-toggle="collapse"
                        data-parent="#productInfoAccordion"
                    >
                        <i className="icon-help" /> {t("Notes")}
            </a>
                </h6>
            </div>
            <div className="collapse" id="collapseNotes" role="tabpanel">
                <div className="card-body" style={{ whiteSpace: "pre-wrap" }}>{product.notes}</div>
            </div>
        </div>
    ) : "";





    const benefit1 = product.benefit1 ? (
        <p>
            <span>
                <i className="icon-square-check" />
                {product.benefit1}
            </span>
        </p>
    ) : ("");

    const benefit2 = product.benefit2 ? (
        <p>
            <span>
                <i className="icon-square-check" />
                {product.benefit2}
            </span>
        </p>
    ) : ("");
    return (
        <Fragment>
         
            {benefit1}
            {benefit2}
            {product.drop !== Drop.NoDrop && (<p className="padding-bottom-1x">
                <span className={'drop-icon ' + product.drop} />
                <span className='drop-text'>
                    {t(product.drop)}
                </span>
            </p>)}
            <ProductPoints settings={props.settings} product={product} />
            {/*{!product.isBom && <ProductPoints settings={props.settings} product={product} />}*/}
            <div className="accordion" id="productInfoAccordion" role="tablist">
                {benefitsOverview}
                {usage}
                {hints}
                {notes}
            </div>
        </Fragment>
    );
}

